import classNames from "classnames";
import React, { memo } from "react";
import { SlaSectionType, SlaStatus } from "../types";

interface Props {
  selected: SlaStatus | null;
  onChange: (status: SlaStatus | null) => void;
  sectionType: SlaSectionType;
}

// api-contract §1.2/§1.3 / react-frontend-tasks F3 [Corrects breakdown]:
// Neither section has an "All" pill; the open section has NO "On Time" pill
// (open on_time tasks are outside the target window and are never returned).
const OPEN_PILLS: { label: string; value: SlaStatus | null }[] = [
  { label: "Upcoming", value: "upcoming" },
  { label: "At Risk", value: "at_risk" },
  { label: "Breached", value: "breached" },
];

const COMPLETED_PILLS: { label: string; value: SlaStatus | null }[] = [
  { label: "Ahead", value: "ahead" },
  { label: "On Time", value: "on_time" },
  { label: "At Risk", value: "at_risk" },
  { label: "Breached", value: "breached" },
];

const StatusFilterPills = ({ selected, onChange, sectionType }: Props) => {
  const PILLS = sectionType === "open" ? OPEN_PILLS : COMPLETED_PILLS;

  return (
    <div className="flex gap-2 mb-4">
      {PILLS.map((pill) => (
        <button
          key={pill.label}
          // Clicking an already-selected pill toggles it back to null
          // (show-all-within-section).
          onClick={() => onChange(selected === pill.value ? null : pill.value)}
          className={classNames(
            "px-4 py-1 rounded-full text-13 font-semibold border transition-colors",
            {
              "bg-primary text-white border-primary": selected === pill.value,
              "bg-white text-black-60 border-black-20 hover:border-primary hover:text-primary":
                selected !== pill.value,
            }
          )}
          type="button"
        >
          {pill.label}
        </button>
      ))}
    </div>
  );
};

export default memo(StatusFilterPills);
